import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=70149252&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=js&"
export * from "./Update.vue?vue&type=script&lang=js&"
import style0 from "./Update.vue?vue&type=style&index=0&id=70149252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70149252",
  null
  
)

export default component.exports